import { Component } from '@angular/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';

import { GridService } from '../../../../tms-shared';
import { RoleService } from '../../services';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrl: './roles.component.scss',
})
export class RolesComponent {
  columnDefs: ColDef[] = [
    this.gridService.text('name', $localize`Name`),
    this.gridService.text('description', $localize`Description`),
    this.gridService.checkbox('showSettings', $localize`Show Settings`),
  ];

  constructor(
    public roleService: RoleService,
    private gridService: GridService,
  ) {}
}
